// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPreview {
  height: 27px;
  width: 27px;
  border: 1px solid #000;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/theam-templates/theam-template-model/theam-template-model.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AACF","sourcesContent":[".colorPreview{\r\n  height:27px;\r\n  width:27px;\r\n  border: 1px solid #000;\r\n  border-radius: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
